import React, {useCallback} from 'react';
import {useNavigate} from 'react-router-dom';
import {Box} from '@mui/material';

import {MainFooter, MainHeader, PageWrapperLayout} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {HomeEnum} from 'presentation/constants';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {StyledGridRoot} from './styles';
import {Content} from '../Content';

const {healthCard} = translations['pt-br'].others.sidebar;

export function HealthCardLayout() {
	const {isTablet} = useMediaQueries();
	const navigate = useNavigate();

	const handleBack = useCallback(() => {
		navigate(HomeEnum.HOME_PAGE);
	}, []);

	return (
		<PageWrapperLayout title={healthCard}>
			<MainHeader title={healthCard} handleBack={handleBack} hideProfileMenu />
			<StyledGridRoot>
				<Content />
			</StyledGridRoot>
			<Box mt="auto" pb={isTablet ? 6 : 0}>
				<MainFooter />
			</Box>
		</PageWrapperLayout>
	);
}
